import { api } from '@/lib/api'

export async function fetchPosReceiptSettings() {
  const { data } = await api.get('/masters/pos-receipt-settings')
  return data.data.pos_receipt
}

/**
 * @param {{ receipt_footer?: string | null }} payload
 */
export async function updatePosReceiptSettings(payload) {
  const { data } = await api.put('/masters/pos-receipt-settings', payload)
  return data.data.pos_receipt
}
